import type { FC } from 'react';

import { Stack, Text } from '@eneco/sparky';

import { LegendIcon } from './LegendIcon';
import { Legend } from '../../../../utils/types';


type Props = {
  label: string;
  type: Legend;
};

export const LegendItem: FC<Props> = ({ type, label }) => {
  return (
    <Stack gap="2" direction="row" alignY="center">
      <LegendIcon type={type} />
      <Text size="BodyXS" weight="bold">
        {label}
      </Text>
    </Stack>
  );
};
